module.exports = __webpack_public_path__ + "ec8ae5a05087629bcf49da7588136105.svg";